const fetchApiError = (error) => {
  let message = 'Something went wrong. Please try again'

  if (error?.response?.data?.message) {
    message = error.response.data.message
  }

  return message
}

export default fetchApiError
